let channelData = [
    {
        name :'地上',
        num: 15,
        data: [
            '関東特定局','関西特定局',
            '全国特定局','読売テレビ',
            '日本テレビ','毎日放送',
            'テレビ朝日','関西テレビ',
            'TBSテレビ','朝日放送',
            'テレビ東京','テレビ大阪',
            'フジテレビ','サンテレビ',
            'TOKYO MX'
        ]
    },
    {
        name :'BS',
        num: 19,
        data: [
            '衛星特定局1','スターチャンネル1',
            '衛星特定局2','スターチャンネル2',
            'BS日テレ','スターチャンネル3',
            'BS朝日','BSアニマックス',
            'BS-TBS','J-SPORTS 1',// 'BSアニマックス',
            'BSジャパン','J-SPORTS 2',
            'BSフジ','J-SPORTS 3',
            'WOWOWプライム', 'J-SPORTS 4',
            'WOWOWライブ','日本映画専門チャンネルHD',
            'WOWOWシネマ'
        ]
    },
    {
        name :'CS',
        num: 14,
        data: [
            '衛星劇場','歌謡ポップスチャンネル',
            'スカイ A sports','キッズステ-ション',
            '日テレG','ディスカバリ-チャンネル',
            'ゴルフネットワ-ク','アニマルプラネット',
            '時代劇専門チャンネル','ヒストリ-チャンネル',
            'ホ-ムドラマチャンネル','旅チャンネル',
            'MUSIC JAPAN TV','ナショナル ジオグラフィック '
        ]
    }
]
export default channelData